// eslint-disable-next-line no-unused-vars

export var DragMixin = {
  name:"DragMixin",
  data() {
    return {
      classToDrag: "",
      classToExpand: "",
      fixMouseX: 0,
      fixMouseY: 0,
      xSartExpand: 0,
      ySartExpand: 0,
      widthStart: 0,
      heightStart: 0,
      limitTop: 0,
      limitBotom: 0,
      limitRight: 0,
      limitLeft: 0,
      expanding: false
    }
  },

  methods: {

    drag(event){
      if(this.expanding) return
      let div = document.querySelector(this.classToDrag)
      if(div){
        let top = event.clientY + this.fixMouseY;
        let left = event.clientX - div.offsetWidth / 2 + this.fixMouseX

        this.dragLeft(left, div);
        this.dragTop(top, div);
      }
    },

    dragLeft(left, div){
      if(left < this.limitLeft) left = this.limitLeft;
      if(left + div.offsetWidth > window.innerWidth)
        left = window.innerWidth - div.offsetWidth - this.limitRight;

      div.style.left = left + 'px'
    },

    dragTop(top, div){
        if(top < this.top()) top = this.top();
        if(top + div.offsetHeight + this.limitBotom > window.innerHeight) 
          top = window.innerHeight - div.offsetHeight - this.bottom();
        div.style.top = top + 'px'
    },

    async expandMove(event){
      let container = document.querySelector(this.classToDrag)

      if(!container)
        return

      if(!this.expanding){
        this.xSartExpand = event.x
        this.ySartExpand = event.y
        this.widthStart = container.offsetWidth
        this.heightStart = container.offsetHeight
      }

      this.expanding = true;

      let x = event.x
      let y = event.y
      let difX = x - this.xSartExpand;
      let difY = y - this.ySartExpand;

      if(x < 0) return;
      if(y < 0) return;

      container.style.height = (this.heightStart + difY) + "px"
      container.style.width = (this.widthStart + difX) + "px"
    },

    expandEnd(){
      setTimeout(() => this.expanding = false, 100);
    },

    top: function() { return document.querySelector('.header').offsetHeight + document.querySelector('.nav-draggable').offsetHeight + this.limitTop },
    bottom: function() { return document.querySelector('.footer').offsetHeight + this.limitBotom }
  },
  mounted() {
  },
};
